import { useEffect, useState, type JSX } from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import useMediaQuery from "@/hooks/use-media-query/use-media-query";
import { MedicalContentSectionProps } from "@/types/LandingPageType";

import Styles from "./medical-content-section.module.css";

function MedicalContentSection({
  titleRiskLevel,
  supportingText,
  travelEligibilityContent,
  linkText,
}: Readonly<MedicalContentSectionProps>): JSX.Element {
  const isdesktop = useMediaQuery("(min-width: 600px)");
  const [showOnDesktop, setShowOnDesktop] = useState(0);

  useEffect(() => {
    if (isdesktop) setShowOnDesktop(1);
    if (!isdesktop) setShowOnDesktop(2);
  }, [isdesktop]);

  return (
    <div data-testid="travel-eligibility">
      <div className=" lg:max-w-custom-wrappersize-lg md:max-w-custom-wrappersize-md max-w-custom-wrappersize-sm w-full flex flex-col items-center mx-auto">
        <div className=" md:mb-spacing-l mb-spacing-m text-center text-dark-text-on-primary">
          <h1 className=" mb-spacing-xxs md:mb-spacing-xs font-header-font md:text-[39px] md:leading-[44.85px] leading-[29.9px] text-[26px] text-center">
            {titleRiskLevel}
          </h1>
          <p className="text-xs leading-[27px] text-surface-neutral-option-2">
            {supportingText}
          </p>
        </div>
      </div>
      <div
        className={` lg:max-w-custom-wrappersize-lg md:max-w-custom-wrappersize-md max-w-custom-wrappersize-sm mx-auto w-full p-spacing-m rounded-radius-lg border-border-transparent border !text-xs
         bg-interactive-overlay-boxcontent font-normal font-body-font [&_ul]:pl-8`}
      >
        <RichText
          data-testid="main-overlay-richText"
          richText={travelEligibilityContent}
        />
      </div>
      {showOnDesktop === 1 && (
        <div
          className={`${Styles.agreement_block} max-w-[454px] w-[100%] text-center mx-auto `}
        >
          <RichText data-testid="main-overlay-richText" richText={linkText} />
        </div>
      )}
    </div>
  );
}

export default MedicalContentSection;
